import React from 'react';
export const CTASection = () => {
  return <section className="py-20 md:py-40 relative overflow-hidden water-texture" data-id="element-139">
      <div className="absolute inset-0 water-gradient" data-id="element-140" />
      <div className="container mx-auto px-4 md:px-6 lg:px-12 relative z-10" data-id="element-141">
        <div className="max-w-4xl mx-auto text-center space-y-6 md:space-y-8" data-id="element-142">
          <h2 className="text-4xl md:text-7xl font-light" data-id="element-143">
            Bring WELLHAUS™ to Your Space
          </h2>
          <p className="text-lg md:text-2xl text-gray-600 font-light max-w-3xl mx-auto" data-id="element-144">
            Sell premium water or impress clients with an exceptional hydration
            experience they'll remember.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center pt-4 md:pt-8" data-id="element-145">
            <a href="#demo" className="px-8 md:px-10 py-3 md:py-4 bg-gray-900 text-white text-sm md:text-base font-medium rounded-full hover:bg-gray-800 transition-colors" data-id="element-146">
              Request a Demo
            </a>
            <a href="#contact" className="px-8 md:px-10 py-3 md:py-4 border border-gray-300 text-gray-700 text-sm md:text-base font-medium rounded-full hover:border-gray-900 hover:text-gray-900 transition-colors" data-id="element-147">
              Contact Sales
            </a>
          </div>
        </div>
      </div>
    </section>;
};